import React from "react";

import { Checkbox, FormControlLabel, Typography } from "@material-ui/core";

export const CommonCheckbox = ({
  id,
  label,
  values,
  errors,
  touched,
  setFieldValue,
  disabled,
  className,
  ...props
}: any) => {
  //Options
  const isValidationFailed = errors && touched && errors[id] && touched[id];
  const errorExtension = (isValidationFailed ? "error" : "");
  const checkboxClassName = className ? className + (errorExtension ? "--" + errorExtension : "") : errorExtension;

  return (
    <FormControlLabel
      className={checkboxClassName}
      control={
        <Checkbox
          {...props}
          disabled={disabled}
          required
          checked={values[id]}
          onChange={(e: any) => setFieldValue(id, e.target.checked)}
          indeterminate={!disabled && values[id] === null}
          name={id}
          color="primary"
          error={isValidationFailed}
        />
      }
      label={<Typography>{label}</Typography>}
    />
  );
};
